import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'Components';
import './MobileTopButton.css';


const MobileTopButton = ({ icon, text, ...rest }) => (
  <Button className="mobile-top-button" {...rest}>
    <Icon icon={`${icon}`} />
    <span className="mobile-top-button__text">{text}</span>
  </Button>
);

MobileTopButton.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  text: PropTypes.string,
  rest: PropTypes.shape({}),
};

export default MobileTopButton;



// WEBPACK FOOTER //
// ./src/components/MobileTopButton/MobileTopButton.jsx